import { useEffect, useState } from 'react';

import { useConfigContext } from 'lib/core/config';
import { useAuthContext } from 'lib/core/context/AuthProvider';

import getInstanceDirectories from 'lib/common/api/getInstanceDirectories';
import getInstanceQueues from 'lib/common/api/getInstanceQueues';
import filterDisabledQueues from 'lib/common/utils/filterDisabledQueues';

import Context from './Context';

function InstanceProvider({ children }) {
  const { fetch_ } = useAuthContext();
  const { config } = useConfigContext();

  const [instanceQueues, setInstanceQueues] = useState([]);
  const [instanceDirectories, setInstanceDirectories] = useState({});

  const setQueueInformation = async () => {
    const response = await getInstanceQueues({ fetch_, config });
    const filteredQueues = filterDisabledQueues({
      allQueues: response,
      disabledQueuePrefix: config.DISABLED_QUEUE_PREFIX,
    });

    setInstanceQueues(filteredQueues);
  };

  const setDirectories = async () => {
    const response = await getInstanceDirectories({ fetch_, config });
    setInstanceDirectories(response);
  };

  useEffect(() => {
    setQueueInformation();
    setDirectories();
  }, []);

  return (
    <Context.Provider
      value={{
        instanceQueues,
        instanceDirectories,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default InstanceProvider;
